var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHashtag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 24 24",
    id: "meteor-icon-kit__regular-hashtag",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.023 0.0167225C11.5662 0.116774 11.9254 0.638179 11.8253 1.18131L10.8698 6.36847H15.7834L16.8057 0.818997C16.9057 0.275862 17.4271 -0.0833287 17.9703 0.0167225C18.5134 0.116774 18.8726 0.638179 18.7725 1.18131L17.817 6.36847H22.9995C23.5518 6.36847 23.9995 6.81617 23.9995 7.36845C23.9995 7.92072 23.5518 8.36843 22.9995 8.36843H17.4486L16.1107 15.6314H21.2627C21.815 15.6314 22.2627 16.0791 22.2627 16.6314C22.2627 17.1837 21.815 17.6314 21.2627 17.6314H15.7423L14.72 23.1809C14.6199 23.724 14.0985 24.0832 13.5554 23.9831C13.0123 23.8831 12.6531 23.3617 12.7531 22.8185L13.7087 17.6314H8.79504L7.77277 23.1809C7.67272 23.724 7.15131 24.0832 6.60818 23.9831C6.06504 23.8831 5.70585 23.3617 5.8059 22.8185L6.76143 17.6314H0.99998C0.447706 17.6314 0 17.1837 0 16.6314C0 16.0791 0.447706 15.6314 0.99998 15.6314H7.12984L8.46777 8.36843H3.31572C2.76345 8.36843 2.31574 7.92072 2.31574 7.36845C2.31574 6.81617 2.76345 6.36847 3.31572 6.36847H8.83618L9.85845 0.818997C9.9585 0.275862 10.4799 -0.0833287 11.023 0.0167225ZM10.5014 8.36843L9.16345 15.6314H14.0771L15.415 8.36843H10.5014Z",
    fill: "#214ba5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashtag);
export default __webpack_public_path__ + "static/media/hashtag.3e6a9a5a5d727177ceaed594bfa4657b.svg";
export { ForwardRef as ReactComponent };